import Dygraph from 'dygraphs';

// If you need it globally (e.g., for inline JS or legacy code):
window.Dygraph = Dygraph;
